export default __webpack_public_path__ + "static/media/avatar.0ba8ff5a.png";